export const commonFormat = 'dd.MM.yyyy';
export const datepickerFormat = 'dd.mm.yyyy';
